<template>
    <div>
        <div class="col-xl-12 col-lg-12 col-md-12 group-row">
            <div class="group-row__label">Agency</div>
            <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4 details-column">
                    <div class="form-field form-field--tree">
                        <label for="agency_id">&nbsp;</label>
                        <treeselect v-model="form_agency.agency" id="agency_id" name="agency_id" :multiple="false"
                            :options="agencies_list" @select="(agency_id) => getServicesByAgency(agency_id)
                                " @deselect="(agency_id) => getServicesByAgency(agency_id)
                                    " :clearOnSelect="true" :beforeClearAll="() => {
                                        handleChange();
                                        return true;
                                    }
                                        " />
                        <span class="error"></span>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 details-column">
                    <div class="row">
                        <div class="col-xl-7 col-lg-7 col-md-7">
                            <div class="form-field form-field--text">
                                <label for="commission">Commission*, %</label>
                                <input type="text" id="commission" name="commission" v-model="form_agency.commission" />
                            </div>
                        </div>
                        <div class="col-xl-5 col-lg-5 col-md-5">
                            <div class="form-field checkbox-wrap" style="
                                    margin-top: 30px;
                                    margin-bottom: 0;
                                    margin-left: 8px;
                                ">
                                <input type="checkbox" id="diminishing" name="diminishing" :checked="diminishing"
                                    @change="diminishing = !diminishing" />
                                <label for="diminishing">
                                    <i class="icon icon-checkmark"></i>
                                </label>
                                Diminishing
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12 details-column">
                    <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-6">
                            <div class="col-xl-12 col-lg-12">
                                <div class="form-field form-field--text">
                                    <label for="commission">Period, m</label>
                                    <input :disabled="!diminishing" v-model="period" type="text" id="period"
                                        name="period" />
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-6 col-lg-6 col-md-6" style="padding-left: 24px">
                            <div class="form-field form-field--text">
                                <label for="commission">Hard cost cap, %
                                </label>
                                <input :readonly="!form_agency.commission_type_id ||
                                    form_agency.commission_type_id != 2
                                    " type="text" id="cap" v-model="form_agency.cap" name="cap"
                                    class="deals-form-cap" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12 details-column">
                    <div class="form-field form-field--text" style="padding-right: 0">
                        <label for="leads_folder">Leads folder
                            <span @click="openLeadsFolderLink" style="color: red"><i
                                    class="icon icon-external-link"></i></span></label>
                        <input v-model="form_agency.leads_folder" readonly type="text" id="leads_folder"
                            name="leads_folder" />
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 details-column">
                    <div class="row details-inline-wrap form-box">
                        <span class="form-box-label">Commission type*</span>
                        <div class="form-field form-field--radiobutton">
                            <template v-for="t in commission_types">
                                <input type="radio" :id="`commission_type_${t.id}`" :checked="form_agency.commission_type_id == t.id
                                    " name="commission_type_id" class="type-create-deals js-edit-commission-type"
                                    :value="t.id" />
                                <label :for="`commission_type_${t.id}`">{{
                                    t.name
                                    }}</label>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-xl-12 col-lg-12 col-md-12 group-row">
            <div class="group-row__label">Brand</div>
            <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4 details-column">
                    <div class="form-field form-field--modal form-field--tree">
                        <label for="brand_id">&nbsp;<span @click="onToggleNewBrandModal">Add new brand</span></label>
                        <treeselect v-model="form_brand.brand" id="brand_id" name="brand_id" :multiple="false"
                            :options="brands_list" @select="onChangeBrand" @input="handleChange"
                            @deselect="handleChange" :clearOnSelect="true" :beforeClearAll="() => {
                                handleChange();
                                return true;
                            }
                                " />
                        <span class="error"></span>
                        <NewBrandModal v-if="isOpenNewBrandModal" :onClose="onToggleNewBrandModal"
                            :onAdd="onCreateNewBrand" :partners="partners" />
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 details-column">
                    <div class="form-field form-field--tree">
                        <label for="sales_rep">Sales rep</label>
                        <treeselect v-model="form_brand.sales_rep" id="sales_rep" name="sales_rep" :multiple="false"
                            :options="sales_rep_list" @input="handleChange" @deselect="handleChange"
                            :clearOnSelect="true" :beforeClearAll="() => {
                                handleChange();
                                return true;
                            }
                                " />
                        <span class="error"></span>
                    </div>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12">
                    <sows-of-deal :is_create="is_create" :deal_id="deal_id" :brand_name="generateSowTitle"
                        :check_sow="check_sow"></sows-of-deal>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12">
                    <services-of-deal :is_create="is_create" :agency_id="agency_id" :brand_types="brand_types"
                        :services="services_list" :selected_service="form_brand.service_id" :deal_id="deal_id"
                        :deal_status="deal_status" :diminishing="diminishing" :deal_period="period"></services-of-deal>
                </div>
                <!-- <div class="col-xl-4 col-lg-4 col-md-4 details-column">
                    <div class="form-field form-field--tree">
                        <label for="service_id">Service*</label>
                        <treeselect
                            v-model="form_brand.service_id"
                            id="service_id"
                            name="service_id"
                            :multiple="false"
                            :options="services_list"
                            @select="handleChange"
                            @deselect="handleChange"
                            :beforeClearAll="
                                () => {
                                    handleChange();
                                    return true;
                                }
                            "
                        />
                        <span class="error"></span>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-2">
                    <div class="row details-inline-wrap form-box">
                        <span class="form-box-label">Type*</span>
                        <div class="form-field form-field--radiobutton">
                            <template v-for="t in brand_types">
                                <input
                                    type="radio"
                                    :id="`type_${t.id}`"
                                    checked
                                    name="type_id"
                                    class="type-create-deals js-edit-deal-type"
                                    :value="t.id"
                                />
                                <label
                                    style="
                                        margin-bottom: 5px;
                                        margin-right: 12px;
                                    "
                                    :for="`type_${t.id}`"
                                    >{{ t.name }}</label
                                >
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-2">
                    <div class="form-field form-field--datepicker">
                        <label for="kickoff_date">Kick-off date</label>
                        <input
                            type="text"
                            id="kickoff_date"
                            v-model="form_brand.kick_off_day"
                            name="kickoff_date"
                        />
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 details-column">
                    <div class="form-field form-field--file">
                        <label for="type">SOW</label>
                        <input
                            type="file"
                            id="agreement"
                            name="agreement"
                            hidden
                        />
                        <button type="button" class="btn btn--file">
                            File
                            <i class="icon icon-plus"></i>
                        </button>
                        <span class="filename"></span>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 details-column"></div>
                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12">
                    <div
                        class="form-field checkbox-wrap checkbox-wrap--one-time-setup"
                    >
                        <label>&nbsp;</label>
                        <input
                            v-model="form_brand.one_time_setup_fee"
                            type="checkbox"
                            id="one-time-setup"
                            class="one-time-setup"
                            name="one_time_setup_fee"
                        />
                        <label for="one-time-setup">
                            <i class="icon icon-checkmark"></i>
                        </label>
                        One time setup fee
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-2">
                    <div class="form-field form-field--text">
                        <label for="type">Number of payments</label>
                        <input
                            type="text"
                            :readonly="form_brand.brand_type != 2"
                            class="js-num-of-payments-deal-edit"
                            v-model="form_brand.number_of_payments"
                            id="num_of_payments"
                            name="payments_number"
                        />
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import axios from "axios";

import NewBrandModal from "./modals/AddNewBrand.vue";

import { set_is_changed } from "../../../helpers/_check_unsaved";

export default {
    name: "AgencyAndBrandForm",
    props: [
        "agencies",
        "brands",
        "agency_commision",
        "agency_cap",
        "is_allow_cap",
        "commission_type_id",
        "commission_types",
        "services",
        "agency_id",
        "brand_id",
        "deal_id",
        "deal_status",
        "service_id",
        "brand_types",
        "brand_type",
        "kick_off_day",
        "number_of_payments",
        "one_time_setup_fee",
        "leads_folder",
        "is_create",
        "partners",
        "check_sow",
        "deal_diminishing",
        "agency_period",
        "agency_partner_commission",
        "sales_rep",
        "sales_rep_list",
        "default_sales_rep",
    ],
    components: {
        Treeselect,
        NewBrandModal,
    },
    data() {
        return {
            form_agency: {
                agency: null,
                commission: /^\d+(\.\d+)?$/.test(this.agency_commision)
                    ? this.agency_commision
                    : null,
                is_allow_cap: false,
                cap: this.agency_cap,
                commission_type_id: 0,
                leads_folder: "",
            },
            form_brand: {
                brand: null,
                service_id: null,
                type: 0,
                kick_off_day: null,
                number_of_payments: 0,
                one_time_setup_fee: false,
                sales_rep: null,
            },
            diminishing: false,
            period: "",
            isStarted: false,
            deals_services: [],
            is_uploaded: false,
            brandOptions: [],
            isOpenNewBrandModal: false,
        };
    },

    computed: {
        agencies_list() {
            if (this.agencies.length) {
                return this.agencies.map((agency) => {
                    return {
                        id: agency.id,
                        label: agency.name,
                        partner_commission_type: agency.partner_commission_type,
                    };
                });
            }
            return [];
        },
        brands_list() {
            if (this.brandOptions.length) {
                return this.brandOptions.map((brand) => {
                    return {
                        id: brand.id,
                        label: brand.name,
                    };
                });
            }
            return [];
        },
        partners_list() {
            if (this.partnersOptions.length) {
                return this.partnersOptions.map((partner) => {
                    return {
                        id: partner.id,
                        label: partner.name,
                    };
                });
            }
        },
        services_list() {
            if (this.deals_services.length) {
                return this.deals_services;
            }
            return [];
        },

        generateSowTitle() {
            const brand = this.brands.find(
                (b) => b.id === this.form_brand.brand
            );

            return brand ? brand.name : "";
        },
    },

    watch: {
        diminishing(val) {
            if (val === false) {
                this.period = "";
            }
        },
        "form_agency.agency": function (newVal, oldVal) {
            //if (newVal > 0) {
            axios
                .post("/agencies/getAgencyById", {
                    agency_id: newVal,
                })
                .then((res) => {
                    if (!this.commission_type_id || oldVal)
                        this.form_agency.commission_type_id =
                            res.data.commission_type;
                    if (!this.form_agency.cap) {
                        this.form_agency.cap = res.data.default_cap;
                    }
                    if (
                        this.is_create &&
                        !/^\d+$/.test(this.agency_commision)
                    ) {
                        this.form_agency.commission = res.data.commission;
                    }
                    if (
                        !this.is_create &&
                        newVal !== oldVal &&
                        !this.isStarted
                    ) {
                        this.form_agency.commission = res.data.commission;
                    }
                    this.form_agency.leads_folder = res.data.leads_folder;

                    if (!this.isStarted) {
                        this.diminishing = res.data.diminishing;
                        this.period = res.data.period;
                    }

                    this.isStarted = false;
                })
                .catch((err) => console.log(err));
            //}
        },
    },
    mounted() {
        this.isStarted = true;
        this.deals_services = JSON.parse(JSON.stringify(this.services));

        this.form_agency.is_allow_cap = this.is_allow_cap;
        this.form_agency.commission_type_id =
            this.commission_type_id !== 0 ? this.commission_type_id : null;
        this.form_agency.agency = this.agency_id !== 0 ? this.agency_id : null;
        this.form_brand.brand = this.brand_id !== 0 ? this.brand_id : null;
        this.form_brand.sales_rep =
            this.sales_rep !== 0 ? this.sales_rep : null;
        this.form_brand.service_id =
            this.service_id !== 0 ? this.service_id : null;
        this.form_brand.brand_type =
            this.brand_type !== 0 ? this.brand_type : null;
        this.form_brand.kick_off_day = this.kick_off_day
            ? this.kick_off_day
            : null;
        this.form_brand.number_of_payments = this.number_of_payments
            ? this.number_of_payments
            : 0;
        this.form_brand.one_time_setup_fee = this.one_time_setup_fee;
        if (this.agency_id) {
            this.getServicesByAgency(
                {
                    id: this.agency_id,
                    partner_commission_type: this.agency_partner_commission
                        ? this.agency_partner_commission
                        : 1,
                },
                true
            );
        }

        this.form_agency.leads_folder = this.leads_folder;
        this.brandOptions = this.brands;
        this.partnersOptions = this.partners;

        this.diminishing = this.deal_diminishing;
        this.period = this.agency_period;

        if (!this.is_create) {
            setTimeout(() => {
                this.is_uploaded = true;
            }, 1000);
        } else {
            this.is_uploaded = true;
            //console.log(this.)
            this.form_brand.sales_rep = this.sales_rep
                ? this.sales_rep
                : this.default_sales_rep;
        }
    },
    methods: {
        getServicesByAgency(agency_id, __init = false) {
            axios
                .post("/agencies/business/getServicesTree", {
                    agency_id: agency_id.id,
                })
                .then((res) => {
                    this.deals_services = res.data;
                    if (
                        !this.deals_services.find(
                            (e) => e.id === this.form_brand.service_id
                        )
                    ) {
                        this.form_brand.service_id = null;
                    }
                })
                .catch((err) => console.log(err));
            const partner_commission_type = document.querySelector(
                'input[name="partner_commission_type"][value="' +
                (agency_id.partner_commission_type
                    ? String(agency_id.partner_commission_type)
                    : "1") +
                '"]'
            );
            if (!__init && partner_commission_type) {
                partner_commission_type.click();
            }
        },
        handleChange() {
            if (this.is_uploaded) set_is_changed();
        },
        async onChangeBrand(brand = null) {
            if (!brand) {
                return;
            }
            if (this.brands && this.brands.length > 0) {
                const selected_brand = this.brands.find(
                    (__brand) => __brand.id === brand.id
                );

                const partner_commission_type = document.querySelector(
                    'input[name="partner_commission_type"]:checked'
                );

                const reffered_name = selected_brand.partner_company.length
                    ? selected_brand.partner_company[0].partner.name
                    : "";

                const company_input = document.querySelector("input#company");
                const company_commission = document.querySelector(
                    "input#partner_commission"
                );

                const nodeRemainingCommPeriod = document.querySelector(
                    "#deal-remaining-referral-partner-commission"
                );

                if (!selected_brand.tied_to_brand) {

                    if (company_input) {
                        company_input.value = reffered_name;
                    }

                    if (company_commission) {
                        company_commission.dataset.default_commission =
                            selected_brand.partner_company.length
                                ? Number(
                                    selected_brand.partner_company[0].partner
                                        .default_commission
                                )
                                : "";
                        company_commission.dataset.direct_commission =
                            selected_brand.partner_company.length
                                ? Number(
                                    selected_brand.partner_company[0].partner
                                        .direct_commission
                                )
                                : "";

                        if (
                            partner_commission_type &&
                            Number(partner_commission_type.value) === 1
                        ) {
                            company_commission.value =
                                company_commission.dataset.default_commission;
                            company_commission.readOnly = false;
                        } else {
                            company_commission.value =
                                company_commission.dataset.direct_commission;
                            company_commission.readOnly = false;
                        }
                    }

                    if (selected_brand.partner_company.length) {
                        const result =
                            await this.getRemainingCommissionPeriodByDealAndPartnerID(
                                this.deal_id,
                                selected_brand.partner_company[0].partner.id
                            );

                        if (result) {
                            if (nodeRemainingCommPeriod)
                                nodeRemainingCommPeriod.classList.remove("hide");
                            const nodeResult =
                                nodeRemainingCommPeriod.querySelector("#result");
                            if (nodeResult) {
                                nodeResult.textContent = result;
                            }
                        } else {
                            if (nodeRemainingCommPeriod)
                                nodeRemainingCommPeriod.classList.add("hide");
                        }

                        if (
                            selected_brand.partner_company[0].partner
                                .eligible_for_sale
                        ) {
                            this.form_brand.sales_rep =
                                selected_brand.partner_company[0].partner.id;
                        } else {
                            this.form_brand.sales_rep = this.default_sales_rep;
                        }
                    } else {
                        if (nodeRemainingCommPeriod)
                            nodeRemainingCommPeriod.classList.add("hide");
                        this.form_brand.sales_rep = this.default_sales_rep;
                    }
                } else {
                    if (nodeRemainingCommPeriod) {
                        nodeRemainingCommPeriod.classList.add("hide");
                    }
                    company_input.value = "";
                    company_commission.value = "";
                    company_input.readOnly = true;
                    company_commission.readOnly = true;
                    this.form_brand.sales_rep = this.default_sales_rep;
                }
            }
        },
        getDataFromParams() {
            try {
                const queryString = window.location.search;

                if (queryString) {
                    const urlParams = new URLSearchParams(queryString);

                    const brand_id = urlParams.get("brand");
                    const agency_id = urlParams.get("agency");
                    const commission = urlParams.get("commission");
                    const type = urlParams.get("type");
                    const hard_cost = urlParams.get("hard_cost");

                    if (agency_id) {
                        const agency = this.agencies.find(
                            (a) => a.id === Number(agency_id)
                        );

                        this.form_agency.agency = agency.id;

                        this.getServicesByAgency({
                            id: agency.id,
                            label: agency.name,
                        });
                    }

                    if (brand_id) {
                        const brand = this.brands.find(
                            (b) => b.id === Number(brand_id)
                        );
                        this.form_brand.brand = brand.id;
                    }
                    if (commission) {
                        this.form_agency.commission = commission;
                    }

                    if (type) {
                        this.form_agency.commission_type_id =
                            type !== 0 ? type : null;
                    }

                    if (hard_cost) {
                        this.form_agency.cap = hard_cost;
                    }
                }
            } catch (err) {
                console.error("getDataFromParams err", err);
            }
        },

        openLeadsFolderLink() {
            const _leads_folder = this.form_agency.leads_folder;

            var res = _leads_folder
                .toString()
                .match(
                    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
                );
            if (res) {
                window.open(_leads_folder, "_blank");
            }
        },
        onCreateNewBrand(data) {
            axios
                .post("/brands/make", data)
                .then((res) => {
                    if (res.data) {
                        const new_brand = {
                            id: res.data.brand.id,
                            name: res.data.brand.name,
                        };

                        this.isOpenNewBrandModal = false;
                        this.brandOptions.push(new_brand);
                        this.form_brand.brand = new_brand.id;

                        const company_input =
                            document.querySelector("input#company");
                        const company_commission = document.querySelector(
                            "input#partner_commission"
                        );

                        if (res.data.brand.partner) {
                            const reffered_name = res.data.brand.partner.name
                                ? res.data.brand.partner.name
                                : "";
                            const reffered_commission = res.data.brand.partner
                                .default_commission
                                ? Number(
                                    res.data.brand.partner.default_commission
                                )
                                : 0;

                            if (company_input) {
                                company_input.value = reffered_name;
                            }

                            if (company_commission) {
                                company_commission.value = reffered_commission;
                            }
                        } else {
                            if (company_input) {
                                company_input.value = "";
                            }

                            if (company_commission) {
                                company_commission.value = 0;
                            }
                        }
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        onToggleNewBrandModal() {
            this.isOpenNewBrandModal = !this.isOpenNewBrandModal;
        },

        async getRemainingCommissionPeriodByDealAndPartnerID(
            deal_id = null,
            partner_id = null
        ) {
            if (!deal_id || !partner_id) {
                return null;
            }

            const result = await axios
                .post("/deals/get_remaining_partner_commission", {
                    dealId: deal_id,
                    partnerId: partner_id,
                })
                .then((res) => {
                    const { result } = res.data;

                    return result;
                })
                .catch((err) => {
                    console.error(
                        "Error getRemainingCommissionPeriodByDealAndPartnerID",
                        err
                    );
                });

            return result;
        },
    },
};
</script>
